import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import {  isTeamLead } from '../Authetication'



export default function TeamLeadRoutes() {


  let auth = {"token": isTeamLead()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
